const Fields = [
    {
        key: true,
        name: "name",
        label: "Name",
        type: "text",
        editable: true,           
        validation: [
            { type: "required"},
            {type: "regex", pattern:"^[a-z0-9-]*$",
            errMsg:"Job group name only supports lowercase letters, numbers and dashes."}
        ],
        helpText: `<p><a href="https://help.aqfer.net/lakeview-api/job-naming-convention?from_search=129606375" target="_blank">Click here to view Naming Convention rules</a></p>`
    },
    {
        name: "description",
        label: "Description",
        visible: true,
        editable: true,
        type: "text"
    },
    {
        name: "type",
        label: "Type",
        visible: true,
        editable: true,
        type: "select",
        options:[
            {label:"Internal", value:"internal"},
            {label:"External", value:"external"}
        ]
    },
    {
        name: "jobs",
        label: "Jobs",
        visible: true,
        editable: true,
        type: "multiselect",
        validation: [{ type: "required"}],
        createOption: false
    }
];

export default Fields;